// assets/custom-b2b-scripts.js

document.addEventListener('DOMContentLoaded', function() {
  console.log(' MSRP Debug: Script loaded');

  // Only run on product pages
  if (!document.body.classList.contains('template-product') && !document.querySelector('.template-product')) { 
    if (!document.querySelector('.js-product-json')) {
      console.log(' MSRP Debug: Not a product page, exiting');
      return;
    }
  }

  const productJsonScript = document.querySelector('.js-product-json');
  const variantInput = document.querySelector('.js-product-form [name="id"]');
  const msrpElement = document.querySelector('.msrp-price');

  console.log(' MSRP Debug: Elements found:', {
    productJson: !!productJsonScript,
    variantInput: !!variantInput,
    msrpElement: !!msrpElement
  });

  if (!productJsonScript || !variantInput || !msrpElement) {
    console.warn(' MSRP Debug: Missing required elements');
    return;
  }

  function updateMsrpDisplay() {
    console.log(' MSRP Debug: Updating display');
    
    try {
      const productData = JSON.parse(productJsonScript.textContent);
      const currentVariantId = parseInt(variantInput.value, 10);
      
      console.log(' MSRP Debug: Product data:', {
        hasMetafields: !!productData.metafields,
        msrp: productData.metafields?.custom?.msrp,
        currentVariantId
      });

      // Find current variant
      const originalVariantData = productData.variants.find(v => v.id === currentVariantId);
      if (!originalVariantData) {
        console.log(' MSRP Debug: Variant not found:', currentVariantId);
        return;
      }

      const variantPriceInCents = originalVariantData.price;
      console.log(' MSRP Debug: Variant price in cents:', variantPriceInCents);

      // Get MSRP from product metafields
      const msrpString = productData.metafields?.custom?.msrp;
      if (!msrpString) {
        console.log(' MSRP Debug: No MSRP found');
        msrpElement.style.display = 'none';
        return;
      }

      // Convert MSRP string (e.g. "$409.99") to number in cents
      const msrpInCents = parseInt(msrpString.replace(/[^0-9.]/g, '').replace('.', ''));
      console.log(' MSRP Debug: Price comparison:', {
        msrpInCents,
        variantPriceInCents,
        shouldShow: msrpInCents > variantPriceInCents
      });

      // Only show MSRP if it's higher than the variant price
      if (msrpInCents > variantPriceInCents) {
        console.log(' MSRP Debug: Showing MSRP');
        msrpElement.style.display = 'inline-block';
        msrpElement.textContent = msrpString; // Use original formatted string for display
      } else {
        console.log(' MSRP Debug: Hiding MSRP (not higher than price)');
        msrpElement.style.display = 'none';
      }

    } catch (e) {
      console.error(' MSRP Debug: Error updating display', e);
    }
  }

  // Run on initial load
  updateMsrpDisplay();

  // Watch for variant changes
  document.addEventListener('variant:change', () => {
    console.log(' MSRP Debug: Variant change detected');
    updateMsrpDisplay();
  });

  console.log(' MSRP Debug: Setup complete');
});
